import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin, Heart, CheckCircle2, AlertCircle } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Veuillez entrer une adresse email valide.');
      return;
    }
    setStatus('loading');
    setMessage('');
    const result = await sendViaWeb3Forms({
      type: 'newsletter',
      fields: {
        email
      }
    });
    if (result.success) {
      setStatus('success');
      setMessage("🎉 Inscription réussie ! Merci de votre intérêt pour l'ADCC.");
      setEmail('');
      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);
    } else {
      setStatus('error');
      setMessage(result.message);
      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);
    }
  };
  return <footer className="bg-[#2C3E50] text-white" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1.2fr_1.5fr] gap-6" data-id="element-27">
          {/* Brand */}
          <div data-id="element-28">
            <div className="flex items-center gap-2 mb-4" data-id="element-29">
              <img src="https://cdn.magicpatterns.com/uploads/qCb6hamLArrr2SMb6t4UDJ/ADCC_logo.png" alt="ADCC - Association Dignité Compétence Création" className="h-12 w-auto max-w-[180px] object-contain" data-id="element-30" />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4" data-id="element-31">
              Association Dignité Compétence Création.
              <br data-id="element-32" />
              Œuvrer pour un développement durable et inclusif au Bénin.
            </p>
            <div className="flex space-x-4" data-id="element-33">
              <a href="https://www.facebook.com/profile.php?id=61587454706476" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook" data-id="element-34">
                <Facebook className="h-5 w-5" data-id="element-35" />
              </a>
              <a href="https://www.linkedin.com/company/association-dignit%C3%A9-comp%C3%A9tence-cr%C3%A9ation-adcc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-36">
                <Linkedin className="h-5 w-5" data-id="element-37" />
              </a>
              <a href="https://www.instagram.com/adcc.benin" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram" data-id="element-38">
                <Instagram className="h-5 w-5" data-id="element-39" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-40">
            <h3 className="text-lg font-semibold mb-4" data-id="element-41">Navigation</h3>
            <ul className="space-y-2" data-id="element-42">
              <li data-id="element-43">
                <Link to="/" className="text-gray-300 hover:text-white text-sm" data-id="element-44">
                  Accueil
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/about" className="text-gray-300 hover:text-white text-sm" data-id="element-46">
                  À Propos
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/actions" className="text-gray-300 hover:text-white text-sm" data-id="element-48">
                  Nos Actions
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/impact" className="text-gray-300 hover:text-white text-sm" data-id="element-50">
                  Notre Impact
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/blog" className="text-gray-300 hover:text-white text-sm" data-id="element-52">
                  Blog
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/formateurs" className="text-gray-300 hover:text-white text-sm" data-id="element-54">
                  Devenir Formateur
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/benevoles" className="text-gray-300 hover:text-white text-sm" data-id="element-56">
                  Devenir Bénévole
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-57">
            <h3 className="text-lg font-semibold mb-4" data-id="element-58">Contact</h3>
            <ul className="space-y-3" data-id="element-59">
              <li className="flex items-start gap-3 text-gray-300 text-sm" data-id="element-60">
                <MapPin className="h-5 w-5 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-61" />
                <span data-id="element-62">
                  Cotonou, Bénin
                  <br data-id="element-63" />
                  Quartier Haie Vive
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-300 text-sm" data-id="element-64">
                <Phone className="h-5 w-5 text-[#1E88E5] flex-shrink-0" data-id="element-65" />
                <span data-id="element-66">+229 01 59 11 13 30</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300 text-sm" data-id="element-67">
                <Mail className="h-5 w-5 text-[#1E88E5] flex-shrink-0" data-id="element-68" />
                <span data-id="element-69">contact@adcc.africa</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-70">
            <h3 className="text-lg font-semibold mb-4" data-id="element-71">Newsletter</h3>
            <p className="text-gray-300 text-sm mb-4" data-id="element-72">
              Restez informé de nos actions et événements.
            </p>
            <form className="flex flex-col gap-2" onSubmit={handleNewsletterSubmit} data-id="element-73">
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Votre email" disabled={status === 'loading'} className="bg-[#34495E] border-none rounded px-4 py-2 text-sm text-white placeholder-gray-400 focus:ring-2 focus:ring-[#1E88E5] disabled:opacity-50" data-id="element-74" />
              <button type="submit" disabled={status === 'loading'} className="bg-[#1E88E5] hover:bg-[#1976D2] text-white px-4 py-2 rounded text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-75">
                {status === 'loading' ? 'Inscription...' : "S'inscrire"}
              </button>

              {message && <div className={`flex items-start gap-2 text-xs p-2 rounded ${status === 'success' ? 'bg-green-500/20 text-green-200' : 'bg-red-500/20 text-red-200'}`} data-id="element-76">
                  {status === 'success' ? <CheckCircle2 className="h-4 w-4 flex-shrink-0 mt-0.5" data-id="element-77" /> : <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" data-id="element-78" />}
                  <span data-id="element-79">{message}</span>
                </div>}
            </form>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-80">
          <p className="text-gray-400 text-sm" data-id="element-81">
            © {new Date().getFullYear()} ADCC Bénin. Tous droits réservés.
          </p>
          <div className="flex items-center gap-1 text-gray-400 text-sm" data-id="element-82">
            <span data-id="element-83">Fait avec</span>
            <Heart className="h-4 w-4 text-red-500 fill-current" data-id="element-84" />
            <span data-id="element-85">pour la communauté</span>
          </div>
        </div>
      </div>
    </footer>;
}